/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./deliver-info.vue?vue&type=template&id=01c8fffc&"
import script from "./deliver-info.vue?vue&type=script&lang=js&"
export * from "./deliver-info.vue?vue&type=script&lang=js&"
import style0 from "./deliver-info.vue?vue&type=style&index=0&id=01c8fffc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports